<script lang="ts">
</script>

<aside class="LayoutUser">
  <p class="user">
    <span class="acronym"><span>JDo</span></span>
    <span class="name">John Doe</span>
  </p>
</aside>

<style lang="scss">
  @use '../../styles/mixins';

  .user {
    position: relative;
    display: inline-flex;
    gap: 0.5em;
    cursor: default;
    pointer-events: none;
    white-space: nowrap;

    .acronym {
      font-size: calc(var(--font-size) * 1.5);
      position: relative;
      display: inline-block;
      background: #1a251e;
      border-radius: 50%;
      width: 1em;
      height: 1em;
      text-align: center;

      span {
        position: relative;
        font-size: 0.45em;
        line-height: 1em;
        margin: 0;
        padding: 0;
        font-weight: bold;
        top: -0.65em;
        color: #fff;
      }
    }

    .name {
      display: none;
      font-size: calc(var(--font-size) * 1.15);

      @include mixins.greaterNav() {
        display: inline-block;
      }
    }
  }
</style>
